import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { IContextMenuItem } from '../../../interfaces/icontext-menu-item.interface';
import { FormBuilderComponent } from '../../../components/form-builder/form-builder.component';
import { ContextMenuItemDivider } from '../../menu/context-menu-item-base';
import {
    MoveRowUpContextMenuData,
    MoveRowDownContextMenuData,
    InsertRowAboveContextMenuData,
    InsertRowBelowContextMenuData,
    CellOperationsRowMenuDivider,
    MergeRowCellsContextMenuData,
    SeparateRowCellsContextMenuData,
    DeleteRowContextMenuData,
    DeleteBlankRowsContextMenuData
} from './row-menu-classes';

export class FormBuilderRowContextMenuData {
    // Properties.
    private rowContextMenuData: IContextMenuItem[];

    public get RowContextMenuData(): IContextMenuItem[] {
        return this.rowContextMenuData;
    }

    // Constructor.
    public constructor(private component: FormBuilderComponent) {
        //this.structureComponent = structureComponent;

        this.rowContextMenuData = [
            new MoveRowUpContextMenuData('Move Up', this.component),
            new MoveRowDownContextMenuData('Move Down', this.component),
            new InsertRowAboveContextMenuData('Insert Row Above', this.component),
            new InsertRowBelowContextMenuData('Insert Row Below', this.component),

            new CellOperationsRowMenuDivider(this.component),
            new MergeRowCellsContextMenuData('Merge Cells', this.component),
            new SeparateRowCellsContextMenuData('Separate Cells', this.component),

            new ContextMenuItemDivider(),
            new DeleteRowContextMenuData('Delete', this.component),
            new DeleteBlankRowsContextMenuData('Delete Blank Rows', this.component)
        ];
    }
}
